function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M5.5,24C4.121,24,3,22.878,3,21.5V7.007H0.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5H2V5.5C2,4.121,3.121,3,4.5,3 h4.039C8.784,1.3,10.262,0,12,0s3.216,1.3,3.461,3H19.5C20.878,3,22,4.121,22,5.5v0.507h1.5c0.276,0,0.5,0.224,0.5,0.5 s-0.224,0.5-0.5,0.5H21V21.5c0,1.378-1.122,2.5-2.5,2.5H5.5z M4,21.5C4,22.327,4.673,23,5.5,23h13c0.827,0,1.5-0.673,1.5-1.5V7.007 H4V21.5z M21,6.007V5.5C21,4.673,20.327,4,19.5,4h-15C3.673,4,3,4.673,3,5.5v0.507h0.437C3.448,6.004,3.472,6,3.5,6 c0.015,0,0.04,0.003,0.061,0.007h16.876C20.448,6.004,20.472,6,20.5,6c0.015,0,0.04,0.003,0.061,0.007H21z M14.448,3 C14.213,1.859,13.187,1,12,1S9.787,1.859,9.552,3H14.448z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,20c-0.276,0-0.5-0.224-0.5-0.5V10c0-0.276,0.224-0.5,0.5-0.5c0.276,0,0.5,0.224,0.5,0.5v9.5 C12.5,19.776,12.276,20,12,20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5,20c-0.276,0-0.5-0.224-0.5-0.5V10c0-0.276,0.224-0.5,0.5-0.5S17,9.724,17,10v9.5C17,19.776,16.776,20,16.5,20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,20C7.224,20,7,19.776,7,19.5V10c0-0.276,0.224-0.5,0.5-0.5S8,9.724,8,10v9.5C8,19.776,7.776,20,7.5,20z"
}));

function SvgBin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin2);
export default __webpack_public_path__ + "static/media/bin-2.455436a4.svg";
export { ForwardRef as ReactComponent };